import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { PlmEventResponseDetailView } from './plmEventResponse-detail-view';
import { PlmEventResponseDetailForm } from './plmEventResponse-detail-form';

export const PlmEventResponseDetail: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<PlmEventResponseDetailView />} />
      <Route path="/edit" element={<PlmEventResponseDetailForm />} />
    </Routes>
  );
};
